export const LOADING_STATIC_TEXT = [
  'Reviewing your request…',
  'Verifying account details…',
  'Preparing an update for you…',
  'Confirming the latest information…',
  'Finalizing changes…',
  'Completing your request…',
];
